import script from "./CBridge.vue?vue&type=script&lang=ts&setup=true"
export * from "./CBridge.vue?vue&type=script&lang=ts&setup=true"

import "./CBridge.vue?vue&type=style&index=0&id=79354e0c&scoped=true&lang=scss"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79354e0c"]])

export default __exports__